import * as Animate from "react-reveal";

const areas = [
  {
    number: "01",
    title: "Programming",
    desc:
      "Understand the logic and foundations behind building technology products.",
  },
  {
    number: "02",
    title: "Product management",
    desc:
      "Learn how to understand problems, shape solutions and organise delivery.",
  },
  {
    number: "03",
    title: "UI/UX design",
    desc:
      "Explore how thoughtful digital experiences are researched and designed.",
  },
  {
    number: "04",
    title: "Data analytics",
    desc:
      "Learn to organise, analyse and communicate information for better decisions.",
  },
];

const NucleusLearningAreasSection = () => {
  return (
    <section
      className="py-16 md:py-20 lg:py-24 px-4"
      id="learning-areas"
      style={{ background: "#fdf2df" }}
    >
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
            <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
            Learning areas
          </p>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start mb-12 lg:mb-14">
            <h2 className="lg:col-span-2 text-3xl md:text-4xl lg:text-5xl font-poppins leading-tight font-black max-w-2xl tracking-[-0.03em] text-primary">
              Build a foundation in high-demand technology skills.
            </h2>
            <p className="text-gray text-base font-poppins leading-relaxed lg:pt-2">
              The current Nucleus page highlights four core learning areas.
            </p>
          </div>
        </Animate.Fade>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {areas.map((area) => (
            <Animate.Fade bottom key={area.number}>
              <article
                className="h-full flex flex-col rounded-2xl p-7 bg-white shadow-course-card"
                style={{ minHeight: "220px" }}
              >
                <span className="text-[#8e5e00] font-poppins text-xs font-extrabold tracking-widest">
                  {area.number}
                </span>
                <h3 className="font-poppins font-bold text-xl text-primary mt-auto mb-3">
                  {area.title}
                </h3>
                <p className="text-gray font-poppins text-sm leading-relaxed m-0">
                  {area.desc}
                </p>
              </article>
            </Animate.Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NucleusLearningAreasSection;
